'use strict';

const _ = require('underscore');
const Mark = require('common/ui/view/svg/mark/index');
const HolyMenu = require('common/ui/view/svg/menu/holy');
const MenuIcon = require('common/ui/view/svg/menu/icon');
const SVGUtil = require('common/ui/view/svg/util');
const Diagrams = require('system/domain/value/diagrams');
const RelationTypeStore = require('system/domain/repository/relation-type');

module.exports = HolyMenu.extend({

    initialize: function(params) {
        this.constructor.__super__.initialize.call(this, params);
        _.bindAll(this, '_selectType');
        this.model = params.model;

        if(this.model) {
            this.listenTo(this.model, 'move', function(){
                const pos = this.model.pos(0.5);
                pos.scale = 1 / this.scale * this.scaleFactor;
                this.svg
                    .attr('transform', SVGUtil.transform(pos))
            });
        }

        const menus = [];
        _.each(Diagrams.getLinks(params.source.get('type'),
            params.target.get('type')), function(type) {
            const typeModel = RelationTypeStore.getRelationTypes()
                .get(type);
            const marks = typeModel.get('marks');
            let icon;
            if (marks && marks.length > 0) {
                icon = MenuIcon.shapeIcon(new Mark(marks[0]));
            } else {
                icon = MenuIcon.fontAwesomeIcon('fa fa-minus');
            }

            const menu = {
                name: type,
                icon: icon,
                click: this._selectType(type),
                text: typeModel.get('name')
            };

            menus.push(menu);
        }, this);

        this.menus = menus;
    },

    _selectType: function(type) {
        return _.bind(function(menu) {
            this.hide();
            this.trigger('select:type', type, this);
        }, this);
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/menu/link-type.js